import React, { Fragment, useState } from "react";
import { Field } from "formik";
import { IconButton, InputAdornment, TextField } from "@material-ui/core";
import { Visibility, VisibilityOff } from "@material-ui/icons";

const FormikTextFields = props => {
  const {
    disabled,
    formikProps,
    isPassword,
    label,
    name,
    onBlur,
    onChange,
    required
  } = props;
  const { errors } = formikProps;

  const [passwordVisibility, setPasswordVisibility] = useState(false);

  return (
    <Field name={name}>
      {({ field }) => (
        <Fragment>
          {isPassword ? (
            <TextField
              {...field}
              disabled={disabled}
              error={errors && Boolean(errors[name])}
              fullWidth
              helperText={errors && errors[name] && errors[name]}
              label={`${label}${required ? " *" : ""}`}
              onBlur={onBlur ? onBlur : field.onBlur}
              onChange={onChange ? onChange : field.onChange}
              type={passwordVisibility ? "text" : "password"}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => setPasswordVisibility(!passwordVisibility)}
                      tabIndex={-1}
                    >
                      {passwordVisibility ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                )
              }}
            />
          ) : (
            <TextField
              {...field}
              disabled={disabled}
              error={errors && Boolean(errors[name])}
              fullWidth
              helperText={errors && errors[name] && errors[name]}
              label={`${label}${required ? " *" : ""}`}
              onBlur={onBlur ? onBlur : field.onBlur}
              onChange={onChange ? onChange : field.onChange}
            />
          )}
        </Fragment>
      )}
    </Field>
  );
};

export default FormikTextFields;
